import { useQuery } from "@tanstack/react-query";

import { get } from "api";
import { Models } from "api/types";

type UsePlatformDomainTokensResult = {
  platformDomainTokens?: Models<"GetMultiPlatformUserPlatformResult">[];
};

export const usePlatformDomainTokens = (): UsePlatformDomainTokensResult => {
  const { data } = useQuery({
    queryKey: ["/multi-platform/list"],
    queryFn: () => get("/multi-platform/list"),
    staleTime: 1000 * 60 * 2,
  });

  return { platformDomainTokens: data?.platformDomainTokens };
};
